import React from 'react';
import Spinner from '@atlaskit/spinner';

import GoogleOneTap from '../../../components/GoogleOneTap';
import { isBooleanFeatureFlagSet } from '../../../utilities/feature-flags';
import { useLoginState } from '../../../utilities/hooks/useLoginState';
import { pageId } from '../constants';
import { useLoginRecoveryOptionsContext } from '../contexts/LoginRecoveryOptionsContext';
import { useSocialLogin } from '../hooks/useSocialLogin';

export const LoginGoogleOneTapRenderBoundary = ({ children }: { children: React.ReactNode }) => {
  const { loginRecoveryOptions } = useLoginRecoveryOptionsContext();

  const { isGoogleOneTapDismissed } = useSocialLogin();

  const { state, isLoading: isPageStateLoading, error: pageStateError } = useLoginState();

  if (isPageStateLoading) {
    return <Spinner label="Login page loading" />;
  } else if (!state || pageStateError) {
    throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
  }

  const { googleAuthClientId } = state.appConfig;
  const { hashedCsrfToken } = state;

  return (
    <GoogleOneTap
      csrfToken={hashedCsrfToken ?? 'token-should-be-loaded'}
      googleAuthClientId={googleAuthClientId}
      source={pageId}
      enabled={
        !isGoogleOneTapDismissed &&
        isBooleanFeatureFlagSet('identity.aid-frontend.google.one.tap.enabled')
      }
      recoveryOptions={loginRecoveryOptions}>
      {children}
    </GoogleOneTap>
  );
};
